// extracted by mini-css-extract-plugin
module.exports = {"errorStyle":"Error404_errorStyle__3CeF7"};